<template>
    <div v-if="options" class="full-view-select">
        <div class="main-option-container" @click.stop="toggleOptions">
            <span class="main-option">
                {{ optionSelected && optionSelected[optionTextField] || 'Sort By' || 'Select an option' }}
            </span>
        </div>
        <transition name="fade-fast">
            <div v-if="showOptions" class="full-view-options-container">
                <a class="close" @click.stop="close"></a>
                <ul class="full-view-options">
                    <li
                        class="full-view-option"
                        v-for="(option, index) in options"
                        :class="{ active: index === optionSelectedIndex }"
                        @click="handleOptionSelected(index, option)"
                        :key="index"
                    >
                        {{ option[optionTextField] }}
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: {
        options: Array,
        optionSelectedIndex: Number,
        optionTextField: String,
        defaultValueText: String,
    },
    data() {
        return {
            showOptions: false,
        };
    },
    computed: {
        optionSelected() {
            return this.options[this.optionSelectedIndex];
        },
    },
    methods: {
        close() {
            this.$emit('closed');
            this.toggleOptions();
        },
        toggleOptions() {
            this.showOptions = !this.showOptions;
            if(this.showOptions) {
                this.$store.commit('menu/hideHeader');
            } else {
                this.$store.commit('menu/resetHeader');
            }
        },
        handleOptionSelected(index, option) {
            this.toggleOptions();
            this.$emit("option-changed", index, option);
        },
    },
};
</script>

<style lang="scss" scoped>
.full-view {
    &-select {
        background: #ffffff;
        position: relative;
        z-index: 99;

        .main-option-container {
            border: 1px solid #000;
            border-radius: 25px;
            font-size: 14px;
            margin: 15px 0 0;
            padding: 15px 25px;
            position: relative;

            &:after {
                content: "";
                position: absolute;
                border-left: 6px solid transparent;
                border-right: 6px solid transparent;
                border-top: 9px solid #000000;
                right: 24px;
                top: calc(50% - 4px);
            }
        }
    }

    &-option {
        font-size: 16px;
        padding: 15px 20px;
        border-bottom: 1px solid #d2d2d2;
        list-style: none;

        &.active {
            font-weight: 700;
            text-decoration: underline;
        }
    }

    &-options {
        height: calc(100% - 45px);
        overflow: scroll;
        border-top: 1px solid #d2d2d2;
        clear: both;

        &-container {
            background: #ffffff;
            bottom: 0;
            left: 0;
            position: fixed;
            right: 0;
            top: 0;

            .close {
                height: 16px;
                width: 16px;
                position: relative;
                vertical-align: middle;
                float: right;
                margin: 15px 20px;

                &:after {
                    content: "";
                    height: 16px;
                    border-left: 1px solid #000;
                    position: absolute;
                    transform: rotate(45deg);
                    left: 8px;
                }

                &:before {
                    content: "";
                    height: 16px;
                    border-left: 1px solid #000;
                    position: absolute;
                    transform: rotate(-45deg);
                    left: 8px;
                }
            }
        }
    }
}
</style>
